import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import RequirePlayer from './components/RequirePlayer';
import Header from './components/Header';
import Landing from './pages/Landing';
import Rules from './pages/Rules';
import Unscramble from './pages/Unscramble';
import WordPuzzle from './pages/WordPuzzle';
import BlurryImages from './pages/BlurryImages';
import ThankYou from './pages/ThankYou';

export default function App() {
  return (
    <AuthProvider>
      <Header />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/rules" element={<RequirePlayer><Rules /></RequirePlayer>} />
        <Route path="/round-1" element={<RequirePlayer><Unscramble /></RequirePlayer>} />
        <Route path="/round-2" element={<RequirePlayer><WordPuzzle /></RequirePlayer>} />
        <Route path="/round-3" element={<RequirePlayer><BlurryImages /></RequirePlayer>} />
        <Route path="/thankyou" element={<RequirePlayer><ThankYou /></RequirePlayer>} />
      </Routes>
    </AuthProvider>
  );
}
